import { render } from "./ModelsView.vue?vue&type=template&id=655a8e27"
import script from "./ModelsView.vue?vue&type=script&lang=js"
export * from "./ModelsView.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__